import * as toolbox from '../components/common/toolbox';
import * as types from './action-types';
import firebase from 'firebase/compat/app';
import { collection, query, where, or, onSnapshot } from "firebase/firestore";
const firestore = firebase.firestore();
const _ = require('lodash');

export async function exportStockParts(handle, columns) {
    
	var stockParts = [];
	var snapshot = await firestore.collection(handle + '/stock-parts/stock-parts').where('deleted', '==', false).get();
	snapshot.forEach((doc) => {
		var entry = {};
		columns.forEach((column) => {
			entry[column] = doc.data()[column];
		});
		stockParts.push({ 
			...entry, 
			id: doc.id, 
			categoryIds: JSON.stringify(doc.data().categoryIds)?.replace(',', '|'), 
		});
	});

	return stockParts;
}

export async function importStockPart(handle, stockPartForm, partsCategories) {

    var batch = firestore.batch();

    var stockPartId = await nextStockPartId(handle, batch);
    stockPartForm.type = 'stock';
    stockPartForm.deleted = false;
    stockPartForm.created = new Date();
    stockPartForm.modified = new Date();

    // check for _category, _primaryVendorId, and _secondaryVendorId
    if (stockPartForm._category) {
        let category = _.find(partsCategories, { id: stockPartForm._category});
        stockPartForm.categoryIds = (category) ? [ category.id ] : [];
    }
    if (stockPartForm._primaryVendorId) {
        var query = await firestore.collection(handle + '/profiles/profiles').where('_id', '==', stockPartForm._primaryVendorId).get();
        if (query.docs[0]?.id) {
            stockPartForm.primaryVendorId = query.docs[0].id;
        }
    }
    if (stockPartForm._secondaryVendorId) {
        var query = await firestore.collection(handle + '/profiles/profiles').where('_id', '==', stockPartForm._secondaryVendorId).get();
        if (query.docs[0]?.id) {
            stockPartForm.secondaryVendorId = query.docs[0].id;
        }
    }
    
    const stockPartsRef = firestore.collection(handle + '/stock-parts/stock-parts');
    batch.set(stockPartsRef.doc(stockPartId), { ...stockPartForm }, { merge: true });

    await batch.commit().catch((error) => {
        toolbox.process_error(error, 'Stock Part NOT Saved!');
    });
};

export function subStockPart(handle, id) {

    return async dispatch => {

        dispatch({ type: types.STOCK_PART_SELECTED + '_PENDING' });

        var query = firestore.collection(handle + '/stock-parts/stock-parts').doc(id);

        const unsubscribe = onSnapshot(query, (doc) => {
            var stockPart = { ...doc.data(), id: doc.id };
            dispatch({ type: types.STOCK_PART_SELECTED + '_FULFILLED', data: stockPart, unsubscribe });
        });

    };
}

export function subStockPartsByAssetId(handle, assetId) {

    return async dispatch => {

        dispatch({ type: types.STOCK_PARTS + '_PENDING' });

        var query = firestore.collection(handle + '/stock-parts/stock-parts').where('associatedAssets', 'array-contains', assetId);

        const unsubscribe = onSnapshot(query, (querySnapshot) => {
            const stockParts = [];
            querySnapshot.forEach((doc) => { stockParts.push({ ...doc.data(), id: doc.id }); });
            dispatch({ type: types.STOCK_PARTS + '_FULFILLED', data: stockParts, unsubscribe });
        });
    };
}

export function subStockPartsByVendorId(handle, vendorId) {

    return async dispatch => {

        dispatch({ type: types.STOCK_PARTS + '_PENDING' });

        const q = query(collection(firestore, handle + '/stock-parts/stock-parts'), or(
            where('primaryVendorId', '==', vendorId), 
            where('secondaryVendorId', '==', vendorId)
        ));

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const stockParts = [];
            querySnapshot.forEach((doc) => { stockParts.push({ ...doc.data(), id: doc.id }); });
            dispatch({ type: types.STOCK_PARTS + '_FULFILLED', data: stockParts, unsubscribe });
        });
    };
}

export function saveStockPart(handle, stockPartForm, stockPartId, callback) {

    return async dispatch => {

        dispatch({ type: types.STOCK_PARTS + '_SAVE_PENDING' });

        var batch = firestore.batch();

        if (parseInt(stockPartId) < 1) {
            stockPartId = await nextStockPartId(handle, batch);
            stockPartForm.deleted = false;
            stockPartForm.created = new Date();
        }
        stockPartForm.modified = new Date();
        
        const stockPartsRef = firestore.collection(handle + '/stock-parts/stock-parts');
        batch.set(stockPartsRef.doc(stockPartId), { ...stockPartForm }, { merge: true });
        batch.commit().then(() => {
            window.toastr.success('The Stock Part record has been successfully saved/updated', 'Stock Part Saved!');
            dispatch({ type: types.STOCK_PARTS + '_SAVE_FULFILLED' });
            if (typeof callback === 'function') callback(stockPartId);
        }).catch((error) => {
            toolbox.process_error(error, 'Stock Part NOT Saved!');
        });
    };
}

export function addStockPartById(handle, id, callback) {

    return async dispatch => {

        firestore.collection(handle + '/stock-parts/stock-parts').doc(id).get().then((doc) => {
            var item = { ...doc.data(), id: doc.id };

            if (typeof callback === 'function') callback(item);
        });
    };
}

async function nextStockPartId(handle, batch) {
    const table = 'stock-parts';
    const field = 'nextStockPartId';
    const startingId = 5000;

    return toolbox.nextId(handle, batch, table, field, startingId);
}